import { render, staticRenderFns } from "./PluginMatomoAnalytics.vue?vue&type=template&id=3d49ba37"
import script from "./PluginMatomoAnalytics.vue?vue&type=script&lang=js"
export * from "./PluginMatomoAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d49ba37')) {
      api.createRecord('3d49ba37', component.options)
    } else {
      api.reload('3d49ba37', component.options)
    }
    module.hot.accept("./PluginMatomoAnalytics.vue?vue&type=template&id=3d49ba37", function () {
      api.rerender('3d49ba37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginMatomoAnalytics.vue"
export default component.exports